import { Observable } from 'rxjs';
import { ApiUrl } from '../api-core/api-constants';
import { apiPost } from '../api-core/api-request';
import apiRequestHookFactory from '../api-core/utility-factories/api-request-hook-factory';
import { apiRedux } from '../api-redux';
import { RatingReq, RatingRtn } from './api-rating.types';

export const useCreateRating = apiRequestHookFactory(
  apiRedux.createRating,
  (data: RatingReq): Observable<RatingRtn> =>
    apiPost<RatingRtn>(ApiUrl.REPAIRS_RATING, data)
);
